import { render, staticRenderFns } from "./vHasmany.vue?vue&type=template&id=aeb14f20&scoped=true&"
import script from "./vHasmany.vue?vue&type=script&lang=js&"
export * from "./vHasmany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb14f20",
  null
  
)

export default component.exports